import { Modal, Row, notification } from "antd";
import "../../styles/DashboardHeader.css";
import ATitle from "core/presentation/components/Title";
import { styles } from "./style";
import { useAppDispatch, useAppSelector } from "core/presentation/store/hooks";
import ShipperMainDashboard from "./ShipperDashboard";
import VehicleOwnerMainDashboard from "./VehicleOwnerDashboard";
import PlatformAdminMainDashboard from "./PlatformAdminDashboard";
import { userThunks } from "user/presentation/store/userSlice";
import { useEffect, useState } from "react";
import Loader from "core/presentation/components/Loader";
import { fleetThunks } from "fleet/presentation/store/fleetSlice";
import AText from "core/presentation/components/Text";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "core/presentation/store";
import ViewContent from "../Content/List/view";
import StaffMainDashboard from "./StaffDashboard";

const DefaultDashboard = () => (
  <Row style={styles.MainRow}>
    <ATitle content="Dashboard" />
  </Row>
);

const DashboardHeader = () => {
  const { userProfile } = useAppSelector((state) => state.user);
  const userRole = userProfile?.user?.roles[0]?.roleCode;
  const [loading, setLoading] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [vehicleOnBoardingCount, setVehicleOnBoardingCount] = useState<number>(0);
  const { contents, isLoading, contentCounts, error } = useSelector((state: RootState) => state.user);
  const [showContentModal, setShowContentModal] = useState(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const fetchOnBoardingData = async () => {
    const hasShownModal = localStorage.getItem(`${userProfile?.user?.userId}_vehicleOnboardingModalShown`);

    if (hasShownModal) return;
    const response = await dispatch(
      fleetThunks.getVehicleOnBoardingListsThunk({
        page: 1,
        input: "",
        filter: "",
        status: "pending",
      }),
    );

    const count = response?.payload?.data?.count;

    if (count > 0) {
      setVehicleOnBoardingCount(count);
      setShowModal(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if ((userRole === "SHIPPER" || userRole === "VEHICLE_OWNER") && !userProfile?.user?.tutorialViewed) {
        await dispatch(
          userThunks.getAllContentThunk({
            page: 0,
            input: "",
            filter: `roles=${userRole}&isActive=true`,
          }),
        );
      }

      if (userRole === "VEHICLE_OWNER") {
        await fetchOnBoardingData();
      }
    };

    fetchData();
  }, [dispatch, userRole, userProfile]);

  useEffect(() => {
    getPlatformDashboardDetails();
  }, [userRole]);

  useEffect(() => {
    if (contents?.length > 0 && !userProfile?.user?.tutorialViewed) {
      setShowContentModal(true);
    } else {
      setShowContentModal(false);
    }
  }, [contents]);

  const handleSkip = () => {
    setShowContentModal(false);
    dispatch(userThunks.updateOwnProfileThunk({ tutorialViewed: true }));
  };

  const getRoleString = (role: string) => {
    if (role === "SHIPPER") return "ROLE_SHIPPER";
    if (role === "VEHICLE_OWNER") return "ROLE_VEHICLE_OWNER";
    if (role === "SUPER_ADMIN") return "ROLE_PLATFORM";
    if (role?.startsWith("STAFF_")) return "ROLE_STAFF";
    return "ROLE_PLATFORM";
  };

  const getPlatformDashboardDetails = async () => {
    if (!userRole) return;
    const response = await dispatch(
      userThunks.getDashboardThunk({
        role: getRoleString(userRole),
      }),
    );

    if (response?.payload?.success) {
      setLoading(false);
    } else {
      notification.error({
        message: "Error",
        description: response?.payload?.message ?? "x",
      });
    }
  };

  if (loading || !userRole) {
    return <Loader />;
  }

  const handleModalConfirm = () => {
    localStorage.setItem(`${userProfile?.user?.userId}_vehicleOnboardingModalShown`, "true");
    setShowModal(false);
    navigate("/pending-vehicle");
  };

  return (
    <>
      <Modal
        title="Vehicle Onboarding Pending"
        open={showModal}
        onOk={handleModalConfirm}
        onCancel={() => {
          localStorage.setItem(`${userProfile?.user?.userId}_vehicleOnboardingModalShown`, "true");
          setShowModal(false);
        }}
        // cancelButtonProps={{ style: { display: "none" } }}
        closable={false}
        maskClosable={false}
        centered
      >
        <AText fontSize={14}>You have {vehicleOnBoardingCount} pending vehicle onboarding requests. Please review them.</AText>
      </Modal>

      {userRole?.startsWith("STAFF_") ? (
        <ShipperMainDashboard />
      ) : (
        (() => {
          switch (userRole) {
            case "SHIPPER":
              return <ShipperMainDashboard />;
            case "VEHICLE_OWNER":
              return <VehicleOwnerMainDashboard />;
            case "SUPER_ADMIN":
              return <PlatformAdminMainDashboard />;
            default:
              return <PlatformAdminMainDashboard />;
          }
        })()
      )}
    </>
  );
};

export default DashboardHeader;
